import React from 'react';

const HelpCenter = () => {
  return (
    <div className={'w-full flex flex-col justify-center items-center lg:px-20 p-4'}>
      <h1 className={'md:text-4xl text-3xl my-6 text-primary-900 font-semibold text-center font-instrument'}>
         Help Center
      </h1>

      <div className={'w-full bg-primary-50 rounded-2xl shadow-lg max-w-5xl text-base p-6 lg:p-10'}>
        <p className={'p-4 md:text-lg text-base font-medium text-[#2b3641] leading-relaxed'}>
          <p className={'mb-2'}>If you need assistance with a product, delivery status, or any order-related concern, please contact us at <b>support@kalapi.store</b> or <b>+91 9125815116</b>
. Our team will respond as quickly as possible to resolve your query.</p>

          <h1 className={'text-xl font-bold  my-6'}>Exchange Policy
          </h1>
          We maintain a transparent and fair exchange process to ensure a smooth experience for all customers. Please read the policy carefully before submitting an exchange request.
        </p>

        <div className={'mt-6'}>
          <h1 className={'text-lg font-semibold mb-2'}>1. Eligibility for Exchange</h1>
          <div className={'ml-6'}>
            <p className={'mb-2'}>We accept exchange requests under the following conditions::</p>
            <p className={'mb-2'}>
            Exchange requests must be raised within 7 days of delivery.
            </p>
            <p className={'mb-2'}>Exchanges are applicable only for Size mismatch , Color mismatch , and Design mismatch.</p>

            <p className={'mb-2'}>Exchanges are not applicable for Wear and tear , Used or washed products , Damage caused after delivery , Personal preference change (e.g., “didn’t like it”)</p>

            <p className={'mb-2'}>Product must be Unused , Unwashed , In original packaging , With all original tags intact</p>
          </div>
        </div>

        <div className={'mt-6'}>
          <h1 className={'text-lg font-semibold mb-2'}>2. Exchange Rules & Conditions</h1>
          <div className={'ml-6 '}>
            <p className={'mb-2'}>Exchanges are subject to product availability.</p>
            <p  className={'mb-2'}>We do not provide cash refunds for exchange requests.</p>
            <p  className={'mb-2'}>The product must be returned in resalable condition.</p>
            <p className={'mb-2'}>All exchange requests are subject to internal quality verification.</p>
            <p className={'mb-2'}>Shipping charges:
              <ul><li>For regular exchanges (size/color/design mismatch), the customer bears the shipping cost.</li>
                <li>Return shipping is free only in approved defective cases.</li>
              </ul>
            </p>
            <p className={'mb-2'}>The product must be returned in resalable condition.</p>
            <p>Exchange approval is subject to internal quality verification.</p>
          </div>
          
        </div>

        <div className={'mt-6 '}>
          <h1 className={'text-lg font-semibold mb-2'}>3. How to Request an Exchange</h1>
          <p>Please follow the steps below to initiate an exchange:</p>
          <div className={'ml-6 mb-2'}>
            <p className={'font-semibold'}>Step 1: Send an Email</p>
            <p>Email us at: support@kalapi.store</p>
          </div>

          <div className={'ml-6 mb-2'}>
            <p className={'font-semibold'}>Step 2: Include Required Details</p>
            <p>Your email must contain: Order Number , Full Name , Registered Mobile Number , Reason for Exchange (clearly explained) , Correct size/color/design required</p>
          </div>

          <div className={'ml-6 mb-2'}>
            <p className={'font-semibold'}>Step 3: Attach Proof</p>
            <p>You must attach Minimum 4 clear images of the product (front, back, tag, close-up of issue) and 1 clear video showing the product condition </p>
            <p>
Close-up of issue (if applicable) clear video showing the product condition</p>
            <p>⚠ Requests  without proper images or video may not be processed.</p>
          </div>

          <div className={'ml-6 mb-2'}>
            <p className={'font-semibold'}>Step 4: Approval & Return Instruction</p>
            <p>Once approved, we will provide further return instructions.</p>
            <p>For defective cases, a shipping label will be provided.</p>
            <p>For non-defective exchanges, you must arrange shipping at your own cost.</p>
          </div>

          <div className={'ml-6 mb-2'}><p className={'font-semibold'}>Step 5: Replacement Processing</p>
            <p>After we receive and verify the returned product, the replacement item will be shipped (subject to availability).</p></div>
        </div>

        <div>
          <p className={'text-lg font-bold  mt-6 text-[#2b3641]'}>Important Notes
          </p>
          <p className={'ml-6'}>Exchange requests submitted after 7 days of delivery will not be accepted.</p>
          <p className={'ml-6'}>Products failing quality inspection will be returned to the customer.</p>
          <p className={'ml-6'}>Kalapi Store reserves the right to decline exchange requests that do not meet policy conditions.</p>
        </div>

      </div>
    </div>
  );
};

export default HelpCenter;
